<template>
  <div class="dynamic_detail">
    <div class="container">
      <div class="box l_flex_row_between">
        <div class="title">
          {{dynamicInfo.title}}
        </div>
        <div class="icons l_flex_row">
          <div class="icon_item">
            <i class="el-icon-view"></i>
            <span class="nub">{{dynamicInfo.views}}</span>
          </div>
          <div class="icon_item">
            <i class="el-icon-time"></i>
            <span class="nub">{{dynamicInfo.created_at}}</span>
          </div>
        </div>
      </div>
      <div class="box">
          <div v-html="dynamicInfo.text" class="text-wrap">
              
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import { handRichtext } from '@/utils/tools.js'
export default {
  components: {},
  props: {
    id:{
      type:String
    }
  },
  data() {
    return {
      dynamicInfo:{},
    };
  },
  watch: {},
  computed: {},
  methods: {},
  created() {
    // console.log('created', this.id);
    this.$api.getActivityDynamicDetail({
      id: this.id
    }).then(res => {
      this.dynamicInfo = res.data;
      this.dynamicInfo.text = handRichtext(this.dynamicInfo.text)
      console.log('res',res);
    }).catch(err => {
      console.log('err',err);
    })
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.dynamic_detail {
  background-color: #eee;
  .container {
    width: 1200px;
    min-width: 1200px;
    margin: 0 auto 50px;
    min-height: 100vh;
    overflow: hidden;
    .box {
      border-radius: 10px;
      background-color: #fff;
      padding: 40px;
      margin: 40px 0;
        .icons{
            .icon_item{
                margin-left: 20px;
                .nub{
                    margin-left: 4px;
                    font-size: 15px;
                    color: #999999;
                }
            }
        }
    }
  }
}
</style>